/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import { CardTitle } from '@usb-ui-tools/react-billpay-layout'
import { useMultilingualService } from '../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../utils/browserutils'
import './edit-header.scss'
import getUSBExBillerLogo from '../../../../utils/extBillerLogo'

/**
 * @typedef {Object} search error
 */
/**
 * Returns Edit Header
 * @function
 * @param {func} onAddbillManually - locale of search error
 * @returns {HTMLElement} Returns error message with redirection link
 */

const EditHeader = ({
  isFieldsValidationError,
  pageErrorMsg,
  payee,
  billerLogoUrl,
  isPayeeInternal
}) => {
  const { HEADER } = useMultilingualService('editBill')
  return (
    <>
      <CardTitle
        {...{
          notificationArray: [
            {
              type: 'error',
              message: pageErrorMsg || HEADER?.PAGEERROR,
              show: isFieldsValidationError
            }
          ],
          AvatarSrc: getUSBExBillerLogo(billerLogoUrl),
          showAvatar: true,
          pageTitleText: (
            <p
              tabIndex={0}
              className="usb-tg-display-small usb-c-usb-blue-primary"
            >
              {HEADER?.EDIT_HEADER}
            </p>
          ),
          cardTitleText: !isOLBOrIpadApp()
            ? <p className="usb-tg-header-medium ">{payee?.displayName}</p> ||
              payee?.nickName
            : '',
          id: 'edit-bill',
          isOLBOrIpadApp,
          mobileZeroBottomMarginFirstChild: !isOLBOrIpadApp(),
          isPayeeInternal,
          mobileZeroTopMarginHeading: true,
          gapThruMarginTop: true
        }}
      />
    </>
  )
}

EditHeader.propTypes = {
  isFieldsValidationError: PropTypes.bool.isRequired,
  pageErrorMsg: PropTypes.string.isRequired,
  payee: PropTypes.objectOf(PropTypes.any),
  billerLogoUrl: PropTypes.func,
  isPayeeInternal: PropTypes.bool.isRequired
}
EditHeader.defaultProps = {
  payee: {},
  billerLogoUrl: null
}

export default EditHeader
